import type { ResumeDto } from "@stackmorph/dto";
import { useQuery } from "@tanstack/react-query";
import type { AxiosResponse } from "axios";

import { RESUMES_KEY } from "@/client/constants/query-keys";
import { axios } from "@/client/libs/axios";

export const fetchResumes = async (organizationId?: string) => {
  const params = organizationId ? { organizationId } : {};
  const response = await axios.get<ResumeDto[], AxiosResponse<ResumeDto[]>>("/resume", { params });

  return response.data;
};

export const useResumes = (organizationId?: string) => {
  const {
    error,
    isPending: loading,
    data: resumes,
  } = useQuery({
    queryKey: organizationId ? [...RESUMES_KEY, { organizationId }] : RESUMES_KEY,
    queryFn: () => fetchResumes(organizationId),
  });

  return { resumes, loading, error };
};
